import { Box, Grid } from "@mui/material";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import { useTranslation } from "react-i18next";
import { Union } from "../unionsApi";
import { StyledTextField } from "../unionsStyles";

interface Props {
  union: Union;
  setUnion: (union: Union) => void;
  selectedUnionId: string;
}

const UnionName = ({ union, setUnion, selectedUnionId }: Props) => {
  const { t } = useTranslation();

  const isLocalUnion = selectedUnionId === "newLocal" || union?.parentId;
  const tradeUnionNumberLength = isLocalUnion ? 4 : 3;
  return (
    <FormSection
      title={isLocalUnion ? t("settings:localUnion") : t("settings:union")}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {isLocalUnion
              ? t("settings:localUnionNameLong")
              : t("settings:unionNameShort")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <StyledTextField
            value={union?.name || ""}
            name="unionName"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              e.target.value.length <= 512 && // Max 512 characters
              setUnion({ ...union, name: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {t("settings:unionAcronym")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <StyledTextField
            debounce={500}
            value={union?.acronym || ""}
            name="unionAcronym"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              e.target.value.length <= 128 && // Max 128 characters
              setUnion({ ...union, acronym: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {isLocalUnion
              ? t("settings:localUnionNumber")
              : t("settings:unionNumber")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <StyledTextField
            value={union?.tradeUnionNumber || ""}
            name="unionNumber"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              (e.target.value === "" || /^\d+$/.test(e.target.value)) && // Numbers only
              e.target.value.length <= tradeUnionNumberLength && // Max 3 characters
              setUnion({ ...union, tradeUnionNumber: e.target.value })
            }
            onBlur={(e: React.FocusEvent<HTMLInputElement>) =>
              e.target.value &&
              setUnion({
                ...union,
                tradeUnionNumber: e.target.value.padStart(tradeUnionNumberLength, "0"),
              })
            }
          />
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default UnionName;
